import { useState } from 'react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import useResizeObserver from 'use-resize-observer'

import { useAnimationFrame } from 'hooks'
import { useSettingsStore, useTimerStore } from 'stores'

import {
  Confetti,
} from 'components'

import {
  Wrapper,
  Name,
  Counters,
  Number,
  Label,
} from './timerStyle'

const Timer = ({
  id,
  color = 'blue_gray',
  name,
  date,
  isRepeating = false,
  repeatFrequency,
}) => {
  const showSeconds = useSettingsStore(state => state.showSeconds)
  const showConfetti = useSettingsStore(state => state.showConfetti)
  const editTimer = useTimerStore(state => state.editTimer)
  const [counters, setCounters] = useState([])

  useAnimationFrame(() => {
    let now = dayjs()
    const years = date.diff(now, 'year')
    now = now.add(years, 'year')
    const days = date.diff(now, 'day')
    now = now.add(days, 'day')
    const hours = date.diff(now, 'hour')
    now = now.add(hours, 'hour')
    const minutes = date.diff(now, 'minute')
    now = now.add(minutes, 'minute')
    const seconds = date.diff(now, 'second')

    setCounters([
      years > 0 && {
        label: 'years',
        number: years,
      },
      (years > 0 || days > 0) && {
        label: 'days',
        number: days,
      },
      (years > 0 || days > 0 || hours > 0) && {
        label: 'hours',
        number: hours,
      },
      (years > 0 || days > 0 || hours > 0 || minutes > 0 || !showSeconds) && {
        label: 'minutes',
        number: date.diff(dayjs(), 'second') <= 0 ? 0 : minutes,
      },
      showSeconds && {
        label: 'seconds',
        number: date.diff(dayjs(), 'second') <= 0 ? 0 : seconds,
      },
    ].filter(Boolean))

    if (isRepeating && date.diff(dayjs(), 'seconds') < 1) {
      editTimer(id, {
        date: date.add(1, repeatFrequency).format('YYYY-MM-DDTHH:mm'),
      })
    }
  })

  const {
    ref: wrapperRef,
    height = 200,
    width = 500,
  } = useResizeObserver({
    box: 'border-box',
  })

  return (
    <Link to={`/timer/${id}`} style={{ textDecoration: 'none' }}>
      <Wrapper data-color={color} ref={wrapperRef}>
        <Counters>
          {counters.map(counter => (
            <div key={counter.label}>
              <Number>{counter.number}</Number>
              <Label>{counter.label}</Label>
            </div>
          ))}
        </Counters>
        <Name>{name}</Name>
        {date.diff(dayjs(), 'second') < 0 && showConfetti && <Confetti height={height} width={width} />}
      </Wrapper>
    </Link>
  )
}

export default Timer